import React from "react"
import { cn } from "../utils"

// =============================================================================
// Props
// =============================================================================
export type LoadingSpinnerProps = {
  className?: string
} & React.SVGProps<SVGSVGElement>

// =============================================================================
// Styles
// =============================================================================
export const loadingSpinnerStyles = ["w-5 h-5 inline-block animate-spin"]

// =============================================================================
// Component
// =============================================================================
export function LoadingSpinner({ className, ...props }: LoadingSpinnerProps) {
  return (
    <svg
      className={cn(loadingSpinnerStyles, className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-slot="spinner"
      {...props}
    >
      <path
        className="opacity-25"
        fill="currentColor"
        fillRule="evenodd"
        d="M12 0a12 12 0 110 24 12 12 0 010-24m0 4a8 8 0 100 16 8 8 0 000-16"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M12 4a8 8 0 00-5.66 13.66l-2.83 2.83a12.1 12.1 0 01-2.65-4.02l-.02-.06a12 12 0 01-.38-7.7l.02-.08a12 12 0 011.41-3.1 12 12 0 012-2.37l.05-.06a12 12 0 012.6-1.79q.54-.27 1.1-.5L7.7.8A12 12 0 019.27.3l.15-.03A12 12 0 0112 0z"
      />
    </svg>
  )
}
